import React from 'react';

const Cart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd">
      <g fill="#141414">
        <g>
          <path
            d="M12.5 1.379c3.364 0 5.098 2.096 5.116 6.02L20 7.4c.299 0 .552.22.594.515l1.51 10.576c.282 1.968-1.086 3.792-3.054 4.073-.169.024-.339.036-.509.036H6.459c-1.988 0-3.6-1.612-3.6-3.6 0-.17.012-.34.036-.51L4.406 7.916C4.448 7.62 4.701 7.4 5 7.4h2.426c-.011-3.923 1.71-6.021 5.074-6.021zM19.48 8.6H5.519L4.073 18.745l-.008.085-.006.17c0 1.325 1.075 2.4 2.4 2.4h12.082c.114 0 .227-.008.34-.024 1.312-.188 2.223-1.403 2.036-2.715L19.48 8.6zM12.5 2.579c-2.632 0-3.894 1.517-3.874 4.82l7.79.001C16.41 4.097 15.133 2.58 12.5 2.58z"
            transform="translate(-339 -12) translate(339 12)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Cart;
